/* ============================================================
   MAWJ UTM Tracker — appends ?utm_* params to WhatsApp messages
   so we know which ad/source the click came from.

   Runs on page load. Finds all <a href="https://wa.me/..."> and
   appends a Arabic source tag to the `text` query parameter
   before the user clicks.
   ============================================================ */
(function () {
  'use strict';

  function getParam(name) {
    var match = location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  var src      = getParam('utm_source');     // e.g. tiktok, instagram
  var camp     = getParam('utm_campaign');   // e.g. valentine_2026
  var medium   = getParam('utm_medium');     // e.g. paid, organic

  // Also persist to sessionStorage so deep links retain attribution
  try {
    if (src)    sessionStorage.setItem('mawj_utm_source', src);
    if (camp)   sessionStorage.setItem('mawj_utm_campaign', camp);
    if (medium) sessionStorage.setItem('mawj_utm_medium', medium);
  } catch (e) { /* private mode */ }

  // Fall back to stored values if not in current URL
  try {
    if (!src)    src    = sessionStorage.getItem('mawj_utm_source')   || '';
    if (!camp)   camp   = sessionStorage.getItem('mawj_utm_campaign') || '';
    if (!medium) medium = sessionStorage.getItem('mawj_utm_medium')   || '';
  } catch (e) { /* ignore */ }

  if (!src && !camp && !medium) return; // nothing to do
  if (window.mawjSkipUtm) return; // page opted out

  // Build Arabic source tag
  var tag = '\n\n── المصدر ──';
  if (src)    tag += '\nالقناة: ' + src;
  if (camp)   tag += '\nالحملة: ' + camp;
  if (medium) tag += '\nالنوع: '  + medium;

  function appendToWaLink(a) {
    var href = a.getAttribute('href') || '';
    if (!/^https:\/\/wa\.me\//i.test(href)) return;
    if (a.dataset.mawjUtmApplied === '1') return;

    try {
      var url = new URL(href);
      var text = url.searchParams.get('text') || '';
      if (text.indexOf('── المصدر ──') !== -1) return; // already tagged
      url.searchParams.set('text', text + tag);
      a.setAttribute('href', url.toString());
      a.dataset.mawjUtmApplied = '1';
    } catch (e) { /* malformed URL */ }
  }

  function scan() {
    document.querySelectorAll('a[href*="wa.me/"]').forEach(appendToWaLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Also re-scan after dynamic insertions (some sections inject WA links late)
  setTimeout(scan, 500);
  setTimeout(scan, 1500);
})();
